import { Component, OnInit } from '@angular/core';
import { HelperService } from 'app/services/helper.service';
import { HTTPService } from 'app/services/http.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-vehicle-fluid-specifications-modal',
  templateUrl: './vehicle-fluid-specifications-modal.component.html',
  styleUrls: ['./vehicle-fluid-specifications-modal.component.scss'],
})
export class VehicleFluidSpecificationsModalComponent implements OnInit {
  orderOrApptId: string;
  isVehiclesLoading: boolean = true;
  vehicle: any = {};
  fluidSpecificationsArr1: any[];
  fluidSpecificationsArr2: any[];

  constructor(
    private httpService: HTTPService, 
    private helperService: HelperService, 
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) {}

  ngOnInit() {
    const { vehicleId, specs } = this.dialogConfig.data;
    if (!specs) {
      this.fetchVehicleFluidData(vehicleId)
    }
    else {
      this.isVehiclesLoading = false;
      this.filterFluidsData(specs);
    }
  }

  goBack() {
    this.dynamicDialogRef.close({ isClose: true });
  }

  fetchVehicleFluidData(vehicleId) {
    this.httpService.getVehicleFluidSpecifications(vehicleId).then(
      (data: any) => {
        this.isVehiclesLoading = false;
        this.filterFluidsData(data.fliudSpecs);
      },
      (err) => {
        this.isVehiclesLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  filterFluidsData(data) {
    this.fluidSpecificationsArr1 = data.filter(d => d.name.toLowerCase() !== 'lug nut torque' && d.name.toLowerCase() !== 'tire pressure' && d.name.toLowerCase() !== 'battery');
    this.fluidSpecificationsArr2 = data.filter(d => d.name.toLowerCase() === 'lug nut torque' || d.name.toLowerCase() === 'tire pressure' || d.name.toLowerCase() === 'battery');
  }
}
